import { useEffect, useRef } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { format } from "date-fns";
import { User } from "lucide-react";
import type { MessageListProps } from "@/types/messages";

export const MessageList = ({ messages }: MessageListProps) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className="space-y-4">
      {messages.map((message) => (
        <div key={message.id} className="flex items-start gap-3">
          <Avatar>
            <AvatarImage src={undefined} />
            <AvatarFallback>
              <User className="h-4 w-4" />
            </AvatarFallback>
          </Avatar>
          <div className="space-y-1">
            <div className="flex items-center gap-2">
              <span className="font-medium">
                {message.sender?.full_name}
              </span>
              <span className="text-sm text-muted-foreground">
                {format(new Date(message.created_at), "MMM d, yyyy 'at' h:mm a")}
              </span>
            </div>
            {message.booking?.property && (
              <p className="text-sm text-muted-foreground">
                Re: {message.booking.property.title}
              </p>
            )}
            <p className="text-sm">{message.content}</p>
          </div>
        </div>
      ))}
      <div ref={messagesEndRef} />
    </div>
  );
};